import { render, staticRenderFns } from "./InterfaceSettingList.vue?vue&type=template&id=bf9be7f6&"
import script from "./InterfaceSettingList.vue?vue&type=script&lang=js&"
export * from "./InterfaceSettingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports